export const REACT_SELECT_CLASSNAME_PREFIX = 'Rafi_select';
